import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DELETE, GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";

// Thunk for getting all CARTS
export const getAllPrescription = createAsyncThunk(
  "get-all-Prescription",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GET(API.PRESCRPTION);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const getSinglePrescription = createAsyncThunk(
  "get-single-Prescription",
  async ({id=""}, { rejectWithValue }) => {
    try {
      const response = await GET(`${API.PRESCRPTION}/single?id=${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for posting CART
export const postPrescription = createAsyncThunk(
  "post-prescription",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await POST(`${API.PRESCRPTION}`, data);
      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create the slice
const wishlitSlice = createSlice({
  name: "prescription",
  initialState: {
    allPrescription: [],
    singlePrescription: {},
    storeInFav: false,
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllPrescription.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllPrescription.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allPrescription = action.payload?.data || [];
        
      })
      .addCase(getAllPrescription.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getSinglePrescription.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getSinglePrescription.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.singlePrescription = action.payload?.data || {};
      
      })
      .addCase(getSinglePrescription.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })
      .addCase(postPrescription.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(postPrescription.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        console.log("State after fulfilled", state);
      })
      .addCase(postPrescription.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      });
  },
});

export default wishlitSlice.reducer;
